const initial = {
  phone: /^[1-9][0-9]{0,2}[-| ]?[0-9]{0,3}[-| ]?[0-9]{0,3}$/,
  email: /^[a-zA-Z0-9_.-]*[@]{0,1}[a-zA-Z0-9-]*[.]{0,1}[a-zA-Z0-9-.]*$/,
  zip: /^[0-9]{0,2}[-]?[0-9]{0,3}$/,
  nip: /^[1-9][0-9]{0,9}$/,
}

const final = {
  phone: /^[1-9]([0-9]{2})([-| ])?([0-9]{3})([-| ])?([0-9]{3})$/,
  email: /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
  zip: /^[0-9]{2}[-]?[0-9]{3}$/,
  nip: /^[1-9]([0-9]{9})$/,
}

export { initial, final }